/*
  Format monétaire par marché — Miravel Paris.

  Les blocs d'offre calculent leurs prix en JavaScript avec Intl.NumberFormat.
  La langue du document ("en", "fr", "es"…) ne suffit pas : "fr" + CAD donne
  "78,49 $CA" et "en" + CAD donne "CA$78.49", deux formats étrangers aux
  habitudes canadiennes. Cette fonction renvoie la locale complète attendue
  pour chaque couple langue/devise, en miroir du snippet Liquid miravel-money.
*/
(function () {
  var CORRESPONDANCES = {
    CAD: { fr: 'fr-CA', en: 'en-CA' },
    EUR: { fr: 'fr-FR', es: 'es-ES', it: 'it-IT', de: 'de-DE', en: 'de-DE' },
    CHF: { de: 'de-CH', fr: 'de-CH', it: 'de-CH', en: 'de-CH' },
    GBP: { en: 'en-GB' },
    USD: { en: 'en-US' }
  };

  window.miravelMoneyLocale = function (devise) {
    var langue = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
    var table = CORRESPONDANCES[devise];
    if (!table) return langue;
    return table[langue] || table.en || table[Object.keys(table)[0]];
  };
})();
